import { useCCEntity } from "components/CC/context/CCEntityContext.tsx";
import { DrawerId, FormId } from "components/CC/types/models.ts";
import { BaseConnectionCreatorDrawer } from "components/CC/UI/BaseConnectionCreatorDrawer.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";

import { BreakerForm } from "../Forms/BreakerForm.tsx";

export const BreakerDrawer = () => {
    const { formFields, customFields } = useCCEntity();
    const { t } = usePaldockTranslation("components.connection-creator");

    return (
        <BaseConnectionCreatorDrawer drawerId={DrawerId.Breaker} title={t("nodes.breaker.drawers.title")}>
            <BreakerForm formId={FormId.BreakerForm} formFields={formFields} customFields={customFields} />
        </BaseConnectionCreatorDrawer>
    );
};
